export default "__VITE_ASSET__BXJLGyjy__"